export default __webpack_public_path__ + "static/media/pubinno_transparent-silver.52b4db6d.png";